import React from 'react';
import {
  Workflow, Sparkles, ShieldCheck, Wallet, Globe2, Zap, LineChart,
  FileText, Bell, Users, Lock, Cpu
} from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

const MODULES = [
  { icon: Workflow, name: 'Practice CRM & Pipeline', body: 'Subclass-aware funnel, occupation → assessing body auto-mapping, conflict scan, one-click Service Agreement generator (OMARA-compliant).' },
  { icon: FileText, name: 'Matter & Case Management', body: 'Auto-generated dynamic checklist from DHA + assessing body. Unified communications log (calls, emails, SMS, portal). Family group linking.' },
  { icon: Cpu, name: 'Lodgement Workspace', body: 'ImmiAccount field mirror pre-filled from matter data. File-size and naming-mask validator. Printable lodgement bundle.' },
  { icon: FileText, name: 'Document Vault + Verification', body: 'AI auto-classification, expiry tracking, WORM audit log, client-signed “true & correct, not fraudulent” declaration, one-click download pack.' },
  { icon: Globe2, name: 'Timeline Client Portal', body: 'Status, next steps, ETA. Mobile-first PWA. 12 languages. E-sign agreements and approvals in-portal.' },
  { icon: Wallet, name: 'Trust & Operating Accounting', body: 'Zero-negative ledger. Three-way recon. Pre-transfer consent gate: closing statement + e-signed consent before trust→operating.' },
  { icon: Sparkles, name: 'AI Copilot', body: 'Qualification → occupation → assessing body. RFI drafter. Doc classifier. Email triage. Policy Pulse impact analysis.' },
  { icon: ShieldCheck, name: 'Compliance & Audit', body: 'CPD tracking, MARN sync, Code version pinning, conflict register, AML/CTF hooks, 7-year retention with auto-purge and return-of-originals pack.' },
  { icon: Users, name: 'Org Admin & RBAC', body: 'Multi-office, seven roles, 2FA mandatory, full audit log. 100% web-based — no desktop dependency, WCAG 2.2 AA.' },
  { icon: Zap, name: 'Integrations', body: 'DHA occupation lists, VETASSESS, ACS, CPA/IPA/CAANZ, Engineers Australia, AHPRA, TRA, Xero, Stripe, M365/Gmail, DocuSign.' },
  { icon: LineChart, name: 'Practice Analytics', body: 'Grant rate by subclass, ageing WIP, profit per matter, per-agent KPIs. Export CSV or Power BI feed.' },
  { icon: Bell, name: 'Policy Pulse', body: 'Ingests DHA, OMARA, LegEnd. AI-summarised. Auto-flags impacted open matters and drafts client comms.' },
];

export default function FeaturesPage() {
  return (
    <>
      <section className="border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-7xl px-6 py-20">
          <div className="mx-auto max-w-3xl text-center">
            <Badge variant="secondary" className="bg-[#2ECC9A]/10 text-[#2ECC9A] border-[#2ECC9A]/30">
              12 modules · one workspace
            </Badge>
            <h1 className="mt-4 font-serif text-5xl font-bold leading-tight tracking-tight text-[#1A3A5C]">
              A complete operating system for Australian immigration practice.
            </h1>
            <p className="mt-4 text-lg text-slate-600">
              Every module was scoped from statutory instruments and practitioner workflow — not repurposed from a generic legal CRM.
            </p>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-6 py-20">
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {MODULES.map((m, i) => {
            const Icon = m.icon;
            return (
              <Card key={m.name} className="border-slate-200 transition-all hover:-translate-y-0.5 hover:shadow-md">
                <CardContent className="p-6">
                  <div className="flex items-center gap-3">
                    <div className="flex h-10 w-10 items-center justify-center rounded-md bg-[#2ECC9A]/10">
                      <Icon className="h-5 w-5 text-[#2ECC9A]" />
                    </div>
                    <span className="font-mono text-xs text-slate-400">M{String(i + 1).padStart(2, '0')}</span>
                  </div>
                  <div className="mt-4 text-lg font-semibold text-[#1A3A5C]">{m.name}</div>
                  <div className="mt-1 text-sm text-slate-600">{m.body}</div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </section>
    </>
  );
}
